import React, { useEffect, useState } from 'react';
import { Space, Tag } from 'antd';
import { useApi } from '../utils/ApiProvider';

const TagSelect = ({ item, errors, getValues, setValue }) => {

  const { apiData } = useApi();

  const [selectedTags, setSelectedTags] = useState([]);

  const handleChange = (tagId, checked) => {
    const nextSelectedTags = checked
      ? [...selectedTags, tagId]
      : selectedTags.filter((id) => id !== tagId);

    setValue(item?.name, nextSelectedTags);
    setSelectedTags(nextSelectedTags);
  };


  useEffect(() => {
    const value = getValues(item.name);
    if (value && Array.isArray(value) && value.length > 0) {
      setSelectedTags(value.map((tag) => tag.id));
      setValue(item.name, value.map((tag) => tag.id));
    }else{
      setSelectedTags([]);
      setValue(item.name, []);
    }
  },[apiData]);

  return (
    <div className="flex flex-col col-span-6 max-[573px]:col-span-12 gap-2">
      <label className="text-[12px] font-medium">{item?.label}</label>
      <div className='flex gap-1'>
        {item?.options.map((tag) => (
          <Tag.CheckableTag
            key={tag.id}
            checked={selectedTags.includes(tag.id)}
            onChange={(checked) => handleChange(tag.id, checked)}
          >
            {tag?.name}
          </Tag.CheckableTag>
        ))}
      </div>
      <div className='text-[red] italic text-[11px]'>{errors[item?.name]?.message}</div>
    </div>
  );
};

export default TagSelect;